module.exports = __webpack_public_path__ + "media/pages/book/components/images/app-reviews/en/joice-2007f96698bccc4a45168d38f6c360a7.jpg";